import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';

const PageContentContainer = (props) => {
  return (
    <Container fluid>
      <Row>
        <Col md="12">
        {props.children}
        </Col>
        </Row>
    </Container>
  )
}

export default PageContentContainer